<template>
  <div>
    <h1>ACHIEVMENT</h1>
  </div>
</template>

<script>
export default {
  name: "ViewAchievment",
};
</script>

<style>
</style>